import { DownloadDriveTimeReportPdfDocument } from '@/api/queries/';
import { DownloadDriveTimeReportPdfInput } from '@/models/gen/graphql';
import graphApi from '@/api';
import { saveFile } from '@/utils/promises';

const [, runRefetchDownloadDriveTimeReportPDF] = graphApi(DownloadDriveTimeReportPdfDocument);

export const downloadDriveTimeReportPDF = async (fileLocation: string): Promise<void> => {
  const input: DownloadDriveTimeReportPdfInput = { fileLocation };
  const res = await runRefetchDownloadDriveTimeReportPDF({ input });
  const presignedUrl = res?.downloadDriveTimeReportPDF?.presignedUrl;
  if (!presignedUrl) throw new Error('Failed to get download URL.');
  saveFile(presignedUrl);
};

export default downloadDriveTimeReportPDF;
